import * as React from 'react';

export * from './stateMachine';

export const LazyKnowledgeAndExperienceSummary = React.lazy(() => import('./component'));
